import IdentityManager from '@arcgis/core/identity/IdentityManager';
import OAuthInfo from '@arcgis/core/identity/OAuthInfo';
import Portal from '@arcgis/core/portal/Portal';
import { bootstrapJSAPI } from '../../../utils/esriLoader';

export default class AuthManager {
  constructor(appId, portalUrl, jsapiUrl, loginWithPopup, use3D, useWVLogin) {
    this.appId = appId;
    this.portalUrl = (useWVLogin) ? "https://wvdof.maps.arcgis.com" : portalUrl;
    this.jsapiUrl = jsapiUrl;
    this.loginWithPopup = loginWithPopup;
    this.use3D = use3D;
  }

  startup = () => {
    return new Promise((resolve, reject) => {
      bootstrapJSAPI(this.portalUrl, this.jsapiUrl, this.use3D)
        .then(() => {
          this.idManager = IdentityManager;
          this.idManager.useSignInPage = !this.loginWithPopup;
          this.oAuthInfo = new OAuthInfo({ appId: this.appId, portalUrl: this.portalUrl, popup: this.loginWithPopup });
          this.idManager.registerOAuthInfos([this.oAuthInfo]);
          resolve();
        })
        .catch(() => { reject(); });
    });
  }

  login = () => {
    return new Promise((resolve, reject) => {
      this.checkLogin().then(
        success => {
          this.getUser().then(resolve, reject);
        },
        failed => {
          this.doLogin().then(user => resolve(user), error => reject(error));
        }
      );
    });
  }

  checkLogin = () => {
    return new Promise((resolve, reject) => {
      const sharingUrl = this.portalUrl + '/sharing';

      this.idManager.checkSignInStatus(sharingUrl)
        .then(credential => {
          window.api.setToken(credential.token);
          window.api.setCredential(credential);
          this.getUser().then(resolve, reject);
        })
        .catch(() => {
          reject('User is not logged in');
        });
    });
  }

  doLogin = () => {
    return new Promise((resolve, reject) => {
      const sharingUrl = this.portalUrl + '/sharing';

      this.idManager.getCredential(sharingUrl, { oAuthPopupConfirmation: false }).then((credential) => {
        this.getUser().then(resolve, reject);
      }).catch(() => { reject(); });
    });
  }

  getUser = () => {
    return new Promise((resolve, reject) => {
      let portal = new Portal({
        url: this.portalUrl,
        authMode: "immediate"
      });
      portal.load().then(() => {
        this.user = portal.user;
        resolve(portal.user);
      }).catch(() => { reject(); });
    });
  }

  logout = () => {
    document.cookie = 'esri_auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    this.idManager.destroyCredentials();

    window.api.logout().then(
      () => {
        window.location.reload();
      },
      error => {
        console.error(error);
      }
    );
  }

  getToken = () => {
    return this.idManager.findCredential(this.portalUrl, this.user.username).token;
  }
}
